// File: src/components/modal/TicketDetailModal.styled.ts
import styled from 'styled-components';

/* ============================================================
   Detalhe do ticket — mesma linguagem "Aurora" do resto do app
   (glass, gradiente de marca, fonte de display), só que resolvida
   como uma conversa de verdade em vez de um bloco de texto plano.
   ============================================================ */

export const Panel = styled.div`
  position: relative;
  width: 100%;
  max-height: 100%;
  display: flex;
  flex-direction: column;
  background: var(--surface-glass);
  backdrop-filter: blur(20px);
  border: 1px solid var(--border-strong);
  border-radius: 20px;
  box-shadow: var(--shadow-lg);
  overflow: hidden;

  /* fio de gradiente no topo — a assinatura visual da marca, discreta */
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: var(--gradient-brand);
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  padding: 22px 24px 16px;
  border-bottom: 1px solid var(--border);
`;

export const HeaderMain = styled.div`
  min-width: 0;
`;

export const TicketNumber = styled.span`
  display: inline-block;
  font-family: var(--font-display);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  color: var(--accent-2);
  background: rgba(59, 130, 246, 0.12);
  border: 1px solid rgba(59, 130, 246, 0.28);
  border-radius: 999px;
  padding: 2px 9px;
  margin-bottom: 8px;
`;

export const TicketTitle = styled.h2`
  margin: 0;
  font-family: var(--font-display);
  font-size: 1.15rem;
  font-weight: 700;
  line-height: 1.35;
  color: var(--text);
  word-break: break-word;
`;

export const ChipRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
`;

export const StatusChip = styled.span<{ $color: string }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 10px 3px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: ${({ $color }) => $color};
  background: ${({ $color }) => `${$color}1f`};
  border: 1px solid ${({ $color }) => `${$color}4d`};

  &::before {
    content: '';
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: ${({ $color }) => $color};
    box-shadow: 0 0 6px ${({ $color }) => $color};
    flex-shrink: 0;
  }
`;

export const MetaRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px 16px;
  margin-top: 14px;
`;

export const MetaItem = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 12.5px;
  color: var(--text-muted);

  svg {
    font-size: 14px;
    opacity: 0.75;
    flex-shrink: 0;
  }

  strong {
    color: var(--text);
    font-weight: 600;
  }
`;

export const CloseBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  border: none;
  border-radius: 10px;
  background: transparent;
  color: var(--text-muted);
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;

  &:hover {
    background: var(--surface-2);
    color: var(--text);
  }

  svg {
    font-size: 19px;
  }
`;

export const Thread = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 20px 24px;
  display: flex;
  flex-direction: column;
  gap: 14px;

  &::-webkit-scrollbar {
    width: 7px;
  }
  &::-webkit-scrollbar-thumb {
    background: var(--scroll-thumb);
    border-radius: 4px;
  }
`;

export const Row = styled.div<{ $mine?: boolean }>`
  display: flex;
  align-items: flex-end;
  gap: 9px;
  flex-direction: ${({ $mine }) => ($mine ? 'row-reverse' : 'row')};
`;

export const Avatar = styled.div<{ $gradient: string }>`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  color: #fff;
  background: ${({ $gradient }) => $gradient};
  border: 1px solid rgba(255, 255, 255, 0.14);
  box-shadow: var(--shadow);
`;

export const BubbleCol = styled.div<{ $mine?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: ${({ $mine }) => ($mine ? 'flex-end' : 'flex-start')};
  max-width: 78%;
  min-width: 0;
`;

export const BubbleMeta = styled.div<{ $mine?: boolean }>`
  display: flex;
  align-items: center;
  gap: 6px;
  margin: ${({ $mine }) => ($mine ? '0 2px 4px 0' : '0 0 4px 2px')};
  font-size: 11px;
  font-weight: 600;
  color: var(--text-dim);

  .edited {
    font-weight: 400;
    font-style: italic;
    opacity: 0.8;
  }
`;

export const Bubble = styled.div<{ $mine?: boolean }>`
  position: relative;
  padding: 9px 13px;
  font-size: 14px;
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-word;
  color: ${({ $mine }) => ($mine ? '#fff' : 'var(--text)')};
  background: ${({ $mine }) =>
    $mine ? 'var(--gradient-brand)' : 'var(--surface-2)'};
  border: 1px solid
    ${({ $mine }) => ($mine ? 'transparent' : 'var(--border-strong)')};
  box-shadow: ${({ $mine }) => ($mine ? 'var(--glow)' : 'var(--shadow)')};
  border-radius: ${({ $mine }) =>
    $mine ? '16px 16px 4px 16px' : '16px 16px 16px 4px'};

  &:hover .bubble-actions {
    opacity: 1;
    pointer-events: auto;
  }
`;

export const BubbleActions = styled.div`
  position: absolute;
  top: -13px;
  right: 6px;
  display: flex;
  gap: 2px;
  padding: 2px;
  background: var(--surface);
  border: 1px solid var(--border-strong);
  border-radius: 8px;
  box-shadow: var(--shadow);
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.15s ease;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    border: none;
    border-radius: 6px;
    background: transparent;
    color: var(--text-muted);
    cursor: pointer;

    &:hover {
      background: var(--surface-2);
      color: var(--text);
    }

    svg {
      font-size: 13px;
    }
  }
`;

export const OriginBadge = styled.span`
  display: inline-flex;
  align-items: center;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--accent-amber);
`;

export const ImageGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
`;

export const ImageThumb = styled.a`
  position: relative;
  display: block;
  width: 88px;
  height: 88px;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.18);

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    transition: transform 0.25s ease;
  }

  .zoom-hint {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(10, 12, 20, 0.35);
    opacity: 0;
    transition: opacity 0.2s ease;

    svg {
      color: #fff;
      font-size: 18px;
    }
  }

  &:hover img {
    transform: scale(1.08);
  }
  &:hover .zoom-hint {
    opacity: 1;
  }
`;

export const EmptyThread = styled.div`
  margin: auto;
  text-align: center;
  color: var(--text-dim);
  font-size: 13px;
  padding: 30px 10px;
`;

export const Composer = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 10px;
  padding: 14px 20px;
  border-top: 1px solid var(--border);
  background: var(--surface);
`;

export const ComposerField = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  background: var(--surface-2);
  border: 1px solid var(--border-strong);
  border-radius: 18px;
  padding: 4px 6px 4px 16px;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &:focus-within {
    border-color: var(--accent);
    box-shadow: 0 0 0 3px rgba(43, 123, 255, 0.16);
  }

  textarea {
    resize: none;
  }
`;

export const SendButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  border: none;
  border-radius: 50%;
  background: var(--gradient-brand);
  color: #fff;
  cursor: pointer;
  box-shadow: var(--glow);
  transition: transform 0.15s ease, opacity 0.15s ease, filter 0.15s ease;

  &:hover:not(:disabled) {
    filter: brightness(1.08);
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.4;
    cursor: default;
    box-shadow: none;
  }

  svg {
    font-size: 17px;
    /* setas de "enviar" costumam ter o bico visualmente descentralizado */
    transform: translateX(-1px);
  }
`;
